__turbopack_context__.v({
  "aspectBox": "CardNewsDetail-module-scss-module__uO2Whq__aspectBox",
  "date": "CardNewsDetail-module-scss-module__uO2Whq__date",
  "image": "CardNewsDetail-module-scss-module__uO2Whq__image",
  "inner": "CardNewsDetail-module-scss-module__uO2Whq__inner",
  "listItem": "CardNewsDetail-module-scss-module__uO2Whq__listItem",
  "textBlock": "CardNewsDetail-module-scss-module__uO2Whq__textBlock",
});
